import React from 'react';
import '../styles/ConfirmModal.css';

const ConfirmModal = ({ isOpen, onConfirm, onDeny, title, message, confirmText, denyText }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{title}</h2>
        <p>{message}</p>
        <div className="modal-actions">
          <button onClick={onDeny} className="btn btn-secondary">{denyText}</button>
          <button onClick={onConfirm} className="btn btn-primary">{confirmText}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
